/**
 *
 * @module searchOverrides
 *
 */
import Check from 'check-types';
import Exception from './../services/exception/entry';
import Util from './../services/util/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString,
    date,
    object
} = Check.assert;

/**
 *
 * @class SearchOverrides
 * @desc Provides a mechanism to override the country or date values
 * for testing search responses
 *
 */
export default class SearchOverrides {

    /**
     *
     * @param {Object} options
     * @param {String} [options.activeDate] - Defines the time of origin for the search request.
     * May affect availability, appearance, and expiration of content. See ISO 8601 for format
     * @param {String} [options.countryCode] - Defines the country of origin for the search request.
     * See ISO 3166-1 alpha-2 for format
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'SearchOverrides(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get activeDate() {
                return `${this.ctor} options.activeDate should be a String with length and conform to ISO 8601`;
            },
            get countryCode() {
                return `${this.ctor} options.countryCode should be a String with length and conform to ISO 3166-1 Alpha-2`; // eslint-disable-line max-len
            }
        };

        object(options, errorMessage.options, InvalidArgumentException);

        const { activeDate, countryCode } = options;

        if (Check.assigned(activeDate) && !Util.dateRegex(activeDate)) {
            date(null, errorMessage.activeDate, InvalidArgumentException);
        }

        if (Check.assigned(countryCode)) {
            nonEmptyString(countryCode, errorMessage.countryCode, InvalidArgumentException);
        }

        /**
         *
         * @access private
         * @type {String|undefiend}
         *
         */
        this.activeDate = activeDate;

        /**
         *
         * @access private
         * @type {String|undefined}
         *
         */
        this.countryCode = countryCode;

    }

}



// WEBPACK FOOTER //
// ./src/content/searchOverrides.js